module.exports = __webpack_public_path__ + "img/7.fa454cfa.jpg";